module.exports = __webpack_public_path__ + "static/media/01A.ebc120ef.png";